import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { ViewModeProvider } from './components/ViewModeContext';
import DataSources from './views/DataSources';
import EvidenceTimeline from './views/EvidenceTimeline';
import SafetyDashboard from './views/SafetyDashboard';
import DecisionTwins from './views/DecisionTwins';
import PatientDigitalTwin from './views/PatientDigitalTwin';
import ProtocolDeviations from './views/ProtocolDeviations';
import IPAccountability from './views/IPAccountability';
import SampleLog from './views/SampleLog';
import SAEClock from './views/SAEClock';
import ProtocolSetup from './views/ProtocolSetup';
import BudgetCalculator from './views/BudgetCalculator';
import RoleSelect from './views/RoleSelect';
import Login from './views/Login';
import HomeCoordinator from './views/HomeCoordinator';
import HomeMonitor from './views/HomeMonitor';
import HomeBudget from './views/HomeBudget';
import ValidationDashboard from './views/ValidationDashboard';
import FormGenerator from './views/FormGenerator';
import FHIRSimulator from './views/FHIRSimulator';
import Swimlane from './views/Swimlane';
import VisitTimeline from './views/VisitTimeline';
import HowItWorks from './views/HowItWorks';
import { DemoProvider } from './components/DemoContext';
import DemoOverlay from './components/DemoOverlay';

function AppLayout() {
  const location = useLocation();
  const isFullPage = location.pathname === '/role-select' || location.pathname === '/login' || location.pathname === '/how-it-works';

  if (isFullPage) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/role-select" element={<RoleSelect />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
      </Routes>
    );
  }

  return (
    <div style={styles.layout}>
      <Sidebar />
      <main style={styles.main}>
        <DemoOverlay />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/role-select" element={<RoleSelect />} />
          <Route path="/protocol-setup" element={<ProtocolSetup />} />
          <Route path="/budget" element={<BudgetCalculator />} />
          <Route path="/data-sources" element={<DataSources />} />
          <Route path="/evidence" element={<EvidenceTimeline />} />
          <Route path="/safety" element={<SafetyDashboard />} />
          <Route path="/patient-twin" element={<PatientDigitalTwin />} />
          <Route path="/decisions" element={<DecisionTwins />} />
          <Route path="/deviations" element={<ProtocolDeviations />} />
          <Route path="/ip" element={<IPAccountability />} />
          <Route path="/samples" element={<SampleLog />} />
          <Route path="/sae" element={<SAEClock />} />
          <Route path="/home/coordinator" element={<HomeCoordinator />} />
          <Route path="/home/monitor" element={<HomeMonitor />} />
          <Route path="/home/budget" element={<HomeBudget />} />
          <Route path="/validation" element={<ValidationDashboard />} />
          <Route path="/forms" element={<FormGenerator />} />
          <Route path="/fhir-sim" element={<FHIRSimulator />} />
          <Route path="/swimlane" element={<Swimlane />} />
          <Route path="/visit-timeline" element={<VisitTimeline />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <DemoProvider>
      <ViewModeProvider>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </ViewModeProvider>
    </DemoProvider>
  );
}

const styles: Record<string, React.CSSProperties> = {
  layout: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#0d1117',
    color: '#e2e8f0',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  main: {
    flex: 1,
    overflow: 'auto',
  },
};

export default App;
